
var content = require("!!../../../../node_modules/css-loader/index.js??ref--12-1!../../../../node_modules/postcss-loader/src/index.js??ref--12-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--12-3!./stepsHeader.scss");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--12-1!../../../../node_modules/postcss-loader/src/index.js??ref--12-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--12-3!./stepsHeader.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--12-1!../../../../node_modules/postcss-loader/src/index.js??ref--12-2!../../../../node_modules/sass-loader/dist/cjs.js??ref--12-3!./stepsHeader.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}